var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.89961 0.766663C1.31971 0.766663 0.849609 1.23676 0.849609 1.81666V7.18333C0.849609 7.76323 1.31971 8.23333 1.89961 8.23333H6.79961C6.99291 8.23333 7.14961 8.07663 7.14961 7.88333V1.81666C7.14961 1.23676 6.67951 0.766663 6.09961 0.766663H1.89961ZM1.54961 6.83333C1.54961 6.44673 1.86301 6.13333 2.24961 6.13333H6.36365C6.41112 6.13333 6.44961 6.17182 6.44961 6.21929V7.44736C6.44961 7.49484 6.41112 7.53333 6.36365 7.53333H2.24961C1.86301 7.53333 1.54961 7.21993 1.54961 6.83333ZM2.94961 2.16666C2.75631 2.16666 2.59961 2.32336 2.59961 2.51666C2.59961 2.70996 2.75631 2.86666 2.94961 2.86666H5.04961C5.24291 2.86666 5.39961 2.70996 5.39961 2.51666C5.39961 2.32336 5.24291 2.16666 5.04961 2.16666H2.94961Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/subtract.f605d1f5.svg";
export { ForwardRef as ReactComponent };